var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuporte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(-4823 -2879)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4823 2879)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4833.264 -2890.378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.764,19.378a11.5,11.5,0,1,0,11.5,11.5A11.5,11.5,0,0,0,29.764,19.378Zm0,22.115A10.615,10.615,0,1,1,40.379,30.878h0A10.629,10.629,0,0,1,29.764,41.493Z",
    fill: "#1d252c",
    stroke: "#1d252c",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.736,23.481v11",
    fill: "#1d252c",
    stroke: "#1d252c",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.015,
    cy: 1.015,
    r: 1.015,
    transform: "translate(28.749 36.245)",
    fill: "#1d252c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuporte);
export default __webpack_public_path__ + "static/media/suporte.c2a25b1fe58e1efebb7826a7638db5fb.svg";
export { ForwardRef as ReactComponent };